import defaultSystemLogo from '@/assets/branding/logo-generic.svg'
import maintenanceFiscalService from '@/services/maintenanceFiscalService'

// Marca del sistema tal como la ve el usuario final. El nombre interno del
// stack (POS Graciela / pos-graciela-api / contenedores) NO se muestra nunca
// en pantalla: hacia afuera esto es VENTAX Gestión, un producto de la suite
// VENTAX — ver `docs/CONVENCION_MARCA_VENTAX.md` en la raíz del workspace.
const SYSTEM_BRANDING = {
  systemName: 'VENTAX',
  systemProductName: 'VENTAX Gestión',
  systemSuiteCredit: 'Un producto de VENTAX',
  systemUrl: 'ventax.app',
  systemLogoUrl: defaultSystemLogo
}

const DEFAULT_COMMERCIAL_BRANDING = {
  commerceName: '',
  commerceLogoUrl: '',
  commerceThermalLogoUrl: '',
  commerceThermalStatus: '',
  systemThermalLogoUrl: '',
  ticketHeaderMode: 'COMERCIO_VENTAX',
  ticketHeaderModesByDocument: {
    FACTURA: 'COMERCIO_VENTAX',
    RECIBO_DINERO: 'SOLO_NOMBRE_COMERCIO'
  },
  ticketPrintWidthMm: 80
}

const resolveClientTradeName = (sucursal = {}, fallback = '') => {
  return (
    sucursal?.nombre_fantasia
    || sucursal?.nombre_sucursal
    || sucursal?.nombre_establecimiento
    || fallback
    || ''
  )
}

export default {
  getSystemBranding() {
    return { ...SYSTEM_BRANDING }
  },
  getDefaultCommercialBranding() {
    return { ...DEFAULT_COMMERCIAL_BRANDING }
  },
  async getPublicBranding() {
    const payload = await maintenanceFiscalService.getPublicBranding()
    return {
      commerceName: payload?.commerce?.name || '',
      commerceLogoUrl: payload?.commerce?.logo_url || '',
      commerceThermalLogoUrl: payload?.commerce?.thermal_logo_url || '',
      commerceThermalStatus: payload?.commerce?.thermal_status || '',
      systemThermalLogoUrl: payload?.system?.thermal_logo_url || '',
      ticketHeaderMode: payload?.tickets?.header_mode || DEFAULT_COMMERCIAL_BRANDING.ticketHeaderMode,
      ticketHeaderModesByDocument: payload?.tickets?.header_modes_by_document || DEFAULT_COMMERCIAL_BRANDING.ticketHeaderModesByDocument,
      ticketPrintWidthMm: Number(payload?.tickets?.print_width_mm || DEFAULT_COMMERCIAL_BRANDING.ticketPrintWidthMm)
    }
  },
  resolveClientTradeName,
  resolveCommerceAndSucursalName(commerceName = '', sucursalName = '') {
    const commerce = String(commerceName || '').trim()
    const sucursal = String(sucursalName || '').trim()
    if (commerce && sucursal) return `${commerce} · ${sucursal}`
    return commerce || sucursal || ''
  }
}
